import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/users/constants';
import type { CurrentUserApi } from '@/modules/users/types';

import { usersQueryKeys } from './queryKeys';

export const useCurrentUserQuery = (
  options?: Omit<
    UseQueryOptions<CurrentUserApi | undefined, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: usersQueryKeys.current(),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.currentUser);
      return data;
    },
    retry: false,
    retryOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    ...options,
  });
};
